module.exports = __webpack_public_path__ + "static/services-a15c807093d92237614aa16c53e743be.mp4";